/**
 * Скрытый макет: копия ленты /app и обычный калькулятор.
 * Правки только по слову — без своих раскладок.
 */

import { Fragment, useCallback, useEffect, useState } from 'react';

import { Brand } from '../../next/Brand';
import { Sign } from '../../next/Sign';
import { logoOf } from '../../next/venues';
import './calc-lab.css';

const LIVE_HINT =
  'кэф этой ноги с ленты, с ячейки — если сверка узнала ту же ставку. сними — застынет, пишешь сам';

const WHY =
  'вбил сумму на одно плечо — второе само. галочка «живой» — кэф этой ноги с ленты, с ячейки — если сверка узнала ту же ставку; снял — застыл, пишешь сам. обратно — эта нога, не сосед и не рождение';

const ROUND_STEPS = [10000, 5000, 1000, 500, 100, 50, 10, 5, 1, 0.1, 0.01] as const;

/** Та же вилка, что на живом столе. */
const FORK = {
  match: 'CYBERSHOKE — BakS eSports',
  profit: '+689 ₽',
  totalRaw: '97776',
  cur: '$',
  legs: [
    {
      code: 'ggbet',
      name: 'GG.bet',
      pick: '2-я карта фора раундов −3.5 BakS eSports',
      odds: '2.580',
      stake: '50.00',
      cents: '12',
    },
    {
      code: 'vbet',
      name: 'Vbet',
      pick: '2-я карта фора раундов +3.5 CYBERSHOKE',
      odds: '1.830',
      stake: '70.50',
    },
  ],
};

type FeedLeg = { code: string; book: string; what: string; sum: string; odd: string };

type FeedRow = {
  sport: string;
  match: string;
  meta: string;
  tier: 'take' | 'ok' | 'small';
  line: 'live' | 'prematch';
  a: FeedLeg;
  b: FeedLeg;
  gain: string;
};

const FEED: FeedRow[] = [
  {
    sport: 'cs2',
    match: 'CYBERSHOKE — BakS eSports',
    meta: 'CS2 · 2-я карта · фора −3.5 по раундам · живая',
    tier: 'take',
    line: 'live',
    a: { code: 'ggbet', book: 'GG.bet', what: 'фора −3.5 BakS eSports', sum: '50.00 $', odd: 'кэф 2.580' },
    b: { code: 'vbet', book: 'Vbet', what: 'фора +3.5 CYBERSHOKE', sum: '70.50 $', odd: 'кэф 1.830' },
    gain: '+689 ₽',
  },
  {
    sport: 'cs2',
    match: 'Gremio Esports — QUINTESSENCIA',
    meta: 'CS2 · Финальная · фора −7.5 по очкам · живая',
    tier: 'ok',
    line: 'live',
    a: { code: 'mellstroy', book: 'Mellstroy', what: 'фора −7.5 Gremio Esports', sum: '65.00 $', odd: 'кэф 1.550' },
    b: { code: 'jetton', book: 'JetTon', what: 'фора +7.5 QUINTESSENCIA', sum: '50.00 $', odd: 'кэф 2.600' },
    gain: '+11.91%',
  },
  {
    sport: 'tabletennis',
    match: 'Solillo, Dominik — Пшемыслав Блохо (Польша)',
    meta: 'настольный теннис · Польша · не ожила',
    tier: 'small',
    line: 'prematch',
    a: { code: 'jetton', book: 'JetTon', what: '2-й сет фора −2.5 Solillo, Dominik', sum: '60.00 $', odd: 'кэф 2.000' },
    b: { code: 'duel', book: 'Duel', what: '2-й сет фора +2.5 Пшемыслав…', sum: '50.00 $', odd: 'кэф 2.450' },
    gain: '+9.09%',
  },
];

function useToast(): { toast: string | null; say: (t: string) => void } {
  const [toast, setToast] = useState<string | null>(null);
  const say = useCallback((text: string) => {
    setToast(text);
    window.setTimeout(() => setToast(null), 1800);
  }, []);
  return { toast, say };
}

function LiveTick(): React.ReactElement {
  return (
    <button type="button" className="nx-calc__live on named" title={LIVE_HINT} aria-pressed>
      <i aria-hidden="true" />
      <em>живой</em>
    </button>
  );
}

function WhyHint(): React.ReactElement {
  return (
    <span className="nx-mock-why">
      <button type="button" className="nx-mock-why__q" aria-label="как пользоваться калькулятором" aria-describedby="nx-mock-why-tip">
        ?
      </button>
      <span id="nx-mock-why-tip" className="nx-mock-why__tip" role="tooltip">
        {WHY}
      </span>
    </span>
  );
}

function RoundPick(): React.ReactElement {
  return (
    <label className="nx-mock-round">
      <span>округлить</span>
      <select defaultValue="100" aria-label="округлить сумму">
        {ROUND_STEPS.map((n) => (
          <option key={n} value={String(n)}>
            {n}
          </option>
        ))}
      </select>
    </label>
  );
}

function CopyMark(): React.ReactElement {
  return (
    <button type="button" className="nx-calc__copy nx-mock-copy" title="скопировать сумму" aria-label="скопировать сумму">
      <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <rect x="5.5" y="5.5" width="8" height="8" rx="1.5" />
        <path d="M10.5 3.5v-1h-8v8h1" />
      </svg>
    </button>
  );
}

function FeeMark({ say }: { say: (t: string) => void }): React.ReactElement {
  return (
    <span className="nx-fee">
      <button type="button" className="nx-fee__go" title="комиссия ноги" aria-label="задать комиссию ноги" onClick={() => say('макет')}>
        %
      </button>
    </span>
  );
}

function MockField({
  value,
  label,
  suffix,
}: {
  value: string;
  label: string;
  suffix?: string;
}): React.ReactElement {
  return (
    <span className="nx-amt nx-mock-field">
      <input className="nx-amt__in" defaultValue={value} inputMode="decimal" aria-label={label} title={label} />
      {suffix !== undefined ? (
        <span className="nx-cur">
          <span className="nx-cur__mark">{suffix}</span>
        </span>
      ) : null}
    </span>
  );
}

function FreeMark(): React.ReactElement {
  return (
    <button type="button" className="nx-mock-free" title="фрибет" aria-label="фрибет">
      <svg viewBox="0 0 58 22" aria-hidden="true" focusable="false">
        <path d="M8 3.5h42q4 0 4 3.2v1.4c-2.4.4-2.4 5.8 0 6.2v1.5q0 3.2-4 3.2H8q-4 0-4-3.2v-1.5c2.4-.4 2.4-5.8 0-6.2V6.7q0-3.2 4-3.2z" />
        <path className="nx-mock-free__perf" d="M17 5.4v11.2" />
        <text x="37" y="14.2" textAnchor="middle">
          FREE
        </text>
      </svg>
    </button>
  );
}

function CallMark({ say }: { say: (t: string) => void }): React.ReactElement {
  return (
    <button type="button" className="nx-mock-call" title="позвать учеников" aria-label="call" onClick={() => say('макет')}>
      <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <path d="M8 2.4A3.4 3.4 0 0 1 11.4 5.8v2l1.3 2.4H3.3L4.6 7.8v-2A3.4 3.4 0 0 1 8 2.4Z" />
        <path d="M6.6 13.1a1.6 1.6 0 0 0 2.8 0" />
      </svg>
      <em>CALL</em>
    </button>
  );
}

function Desk({ say }: { say: (t: string) => void }): React.ReactElement {
  return (
    <div className="nx-tray held">
      <div className="nx-mock-head">
        <div className="nx-mock-head__top">
          <span className="nx-tray__kind">калькулятор</span>
          <div className="nx-mock-bar__acts">
            <button type="button" className="nx-calc__tool nx-mock-icon" title="закрепить" aria-label="закрепить" onClick={() => say('макет')}>
              <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                <path d="M6 2.5h4v4H6Z" />
                <path d="M4 6.5h8" />
                <path d="M8 6.5v8" />
              </svg>
            </button>
            <button type="button" className="nx-calc__tool nx-mock-icon" title="опустошить" aria-label="опустошить" onClick={() => say('макет')}>
              <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                <path d="M3.5 4.5h9" />
                <path d="M6.2 4.5V3.2h3.6v1.3" />
                <path d="M5 6v6.5M8 6v6.5M11 6v6.5" />
                <path d="M4.6 4.5 5.2 13h5.6l.6-8.5" />
              </svg>
            </button>
            <button type="button" className="nx-calc__tool nx-mock-icon" title="закрыть" aria-label="закрыть" onClick={() => say('макет')}>
              <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                <path d="M4.5 4.5 11.5 11.5M11.5 4.5 4.5 11.5" />
              </svg>
            </button>
          </div>
        </div>
        <div className="nx-mock-head__match">
          <button type="button" className="nx-tray__title" onClick={() => say('макет')}>
            {FORK.match}
          </button>
          <WhyHint />
        </div>
      </div>
      <div className="nx-calc nx-calc--desk nx-mock-desk">
        <div className="nx-calc__cols" aria-hidden="true">
          <span>контора</span>
          <span>исход</span>
          <span>кэф</span>
          <span>сумма</span>
          <span>доход</span>
          <i />
        </div>
        <i className="nx-mock-rule" aria-hidden="true" />
        {FORK.legs.map((leg, i) => (
          <Fragment key={leg.code}>
          <div className="nx-calc__row">
            <span className="nx-calc__bk">
              <Brand
                code={leg.code}
                name={leg.name}
                size="s"
                href={`https://${leg.code}.com`}
                onOpen={() => say('макет')}
              />
            </span>
            <span
              className="nx-calc__pick go"
              role="link"
              tabIndex={0}
              title={`${leg.name} · открыть исход на сайте`}
              onClick={(event) => {
                event.stopPropagation();
                say('макет');
              }}
              onKeyDown={(event) => {
                if (event.key !== 'Enter' && event.key !== ' ') return;
                event.preventDefault();
                say('макет');
              }}
            >
              {leg.pick}
            </span>
            <span className="nx-calc__odds">
              <LiveTick />
              <MockField value={leg.odds} label="править кэф" />
              {leg.cents !== undefined ? <i>цена {leg.cents}</i> : null}
            </span>
            <span className="nx-calc__amt">
              <span className="nx-calc__cash">
                <MockField value={leg.stake} label="править сумму" suffix={FORK.cur} />
              </span>
            </span>
            <span className="nx-calc__inc">
              <b>{FORK.profit}</b>
            </span>
            <span className="nx-calc__more">
              <CopyMark />
              <FeeMark say={say} />
              <FreeMark />
            </span>
          </div>
          {i < FORK.legs.length - 1 ? <i className="nx-mock-rule nx-mock-rule--row" aria-hidden="true" /> : null}
          </Fragment>
        ))}
        <div className="nx-calc__foot">
          <div className="nx-mock-foot-left">
            <span className="nx-calc__plus">
              <em>выйдет</em>
              <b className="nx-calc__roi">{FORK.profit}</b>
            </span>
            <span className="nx-calc__sum">
              <em>всего</em>
              <span>{FORK.totalRaw}</span>
            </span>
            <span className="nx-mock-zeros">
              <em>нулевые вилки</em>
              <span>GG.bet: от 2,20616</span>
              <span>Vbet: от 1,6333</span>
            </span>
          </div>
          <div className="nx-mock-foot-right">
            <RoundPick />
            <button type="button" className="nx-calc__tool" onClick={() => say('макет')}>
              в окошко
            </button>
            <button type="button" className="nx-calc__tool" onClick={() => say('макет')}>
              ещё плечо
            </button>
            <button type="button" className="nx-calc__tool" onClick={() => say('макет')}>
              разложить банк
            </button>
            <button type="button" className="nx-calc__tool" onClick={() => say('макет')}>
              в кассу
            </button>
            <CallMark say={say} />
          </div>
        </div>
      </div>
    </div>
  );
}

function MockCoupon({ kind }: { kind: 'pin' | 'pop' }): React.ReactElement {
  const pin = kind === 'pin';
  return (
    <button
      type="button"
      className={`nx-fk__coupon nx-fk__coupon--${kind} ${pin ? 'nx-fk__clip' : 'nx-fk__pop'}`}
      aria-label={pin ? 'в калькулятор' : 'открыть отдельным окном'}
      title={pin ? 'в калькулятор' : 'открыть вилку отдельным окном'}
    >
      <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        {pin ? (
          <>
            <path d="M6 2.5h4v4H6Z" />
            <path d="M4 6.5h8" />
            <path d="M8 6.5v8" />
          </>
        ) : (
          <>
            <path d="M6.5 3.5h-3v9h9v-3" />
            <path d="M9.5 3.5h3v3" />
            <path d="M12.5 3.5 7.5 8.5" />
          </>
        )}
      </svg>
    </button>
  );
}

function MockLeg({ side, index }: { side: FeedLeg; index: 0 | 1 }): React.ReactElement {
  const logo = logoOf(side.code);
  return (
    <span className={`nx-fk__leg ${index === 0 ? 'one' : 'two'}`}>
      <span className="n">
        <b>
          <span>{side.sum}</span>
        </b>
      </span>
      <span className="nx-fk__spot">
        <span className="nx-fk__book">
          {logo !== null && <img className="nx-fk__mk" src={logo} alt="" />}
          <span className="nx-fk__who">
            <span className="nx-fk__at">{side.book}</span>
            <span className="nx-fk__sep"> · </span>
            <span className="nx-fk__what">{side.what}</span>
          </span>
        </span>
      </span>
      <i>{side.odd}</i>
    </span>
  );
}

function ForkLine({ row }: { row: FeedRow }): React.ReactElement {
  return (
    <div
      className={`nx-fk nx-fk--${row.tier}${row.line === 'live' ? ' nx-fk--live' : ''}`}
      data-fork-row=""
      data-line={row.line === 'live' ? 'live' : undefined}
    >
      <MockCoupon kind="pin" />
      <MockCoupon kind="pop" />
      <Sign sport={row.sport} />
      <div className="nx-fk__work">
        <span className="nx-fk__m">{row.match}</span>
        <span className="nx-fk__meta">
          <span className="t">{row.meta}</span>
        </span>
        <MockLeg side={row.a} index={0} />
        <MockLeg side={row.b} index={1} />
      </div>
      <div className="nx-fk__gain">
        <span className="nx-fk__sum">
          <span className="nx-fk__val">{row.gain}</span>
        </span>
      </div>
    </div>
  );
}

function MockHead(): React.ReactElement {
  return (
    <header className="nx-top">
      <div className="nx-wide nx-top__in">
        <div className="nx-logo">FORQ</div>
        <nav className="nx-seg">
          <button type="button">витрина</button>
          <button type="button" aria-pressed="true">
            лайв
          </button>
          <button type="button">прематч</button>
          <button type="button">русские</button>
          <button type="button">переливы</button>
          <button type="button">предикт</button>
          <button type="button">лента 2.0</button>
          <button type="button">касса</button>
          <button type="button">студия</button>
        </nav>
        <div className="nx-top__gap" />
        <div className="nx-pip">
          <i className="nx-pulse still" />
          <span className="nx-lbl">6 площадок в эфире</span>
        </div>
        <button type="button" className="nx-zero-trigger">
          нулевые вилки
        </button>
        <button type="button" className="nx-desk-hand">
          call
        </button>
        <div className="nx-who">
          <span className="nx-who__id">
            <span className="nx-who__face">Р</span>
            <span className="nx-who__text">
              <b>Профиль</b>
            </span>
          </span>
        </div>
      </div>
    </header>
  );
}

export function CalcLab(): React.ReactElement {
  const { toast, say } = useToast();

  useEffect(() => {
    document.body.classList.add('nx-body');
    document.title = 'FORQ · макет калькулятора';
    return () => document.body.classList.remove('nx-body');
  }, []);

  return (
    <div className="nx-root">
      <MockHead />
      <div className="nx-wide">
        <div className="nx-sieve">
          <div className="nx-sieve__head">
            <button type="button" className="nx-sieve__toggle">
              <span className="nx-sieve__caret" aria-hidden="true">
                +
              </span>
              фильтры
            </button>
            <button type="button" className="nx-sieve__money">
              беру от <b>$3.57</b>
            </button>
            <button type="button" className="nx-sieve__money">
              сумма <b>$119</b>
            </button>
            <button type="button" className="nx-sieve__clear">
              сбросить фильтры
            </button>
            <span className="nx-sieve__gap" />
            <div className="nx-sieve__sort" role="group" aria-label="порядок">
              <span className="nx-sieve__grplbl">порядок</span>
              <button type="button" className="on" aria-pressed>
                по деньгам
              </button>
              <button type="button">по свежести</button>
              <button type="button">по надёжности</button>
            </div>
          </div>
        </div>

        <div className="nx-clips">
          <Desk say={say} />
        </div>

        <div className="nx-feed">
          {FEED.map((row, i) => (
            <div key={`${row.match}-${i}`} className="nx-fk-wrap">
              <ForkLine row={row} />
            </div>
          ))}
        </div>
      </div>
      {toast !== null && <div className="nx-desk-toast">{toast}</div>}
    </div>
  );
}
